var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neuer QR-Code"}},[_c('qr-code-form',{attrs:{"qr-code":_vm.qrCode,"submit-label":"QR-Code anlegen","form-submitted":_vm.saveQrCode,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }